import { last } from "lodash";

export const isLastBreadcrumbLink = (breadcrumbGroupId, group) =>
  last(group.hierarchyIds) === breadcrumbGroupId;
